import { cn } from "@/lib/utils";
import React from "react";

export type TCardProps = {
  children: React.ReactNode;
  className?: string;
  muted?: boolean;
};
export function Card({ children, className, muted=true }: TCardProps) {
  return (
    <div
      className={cn(
        "group",
        "relative",
        "flex",
        "flex-col",
        "justify-between",
        "items-start",
        "hover:shadow-lg",
        "hover:shadow-muted",
        "rounded-2xl",
        "overflow-hidden",
        "transition-all",
        "duration-300",
        "snap-center",
        {"gap-8 bg-muted p-8": muted},
        className
      )}
    >
      {children}
    </div>
  );
}
